import React, { FC, ReactNode, ButtonHTMLAttributes } from 'react';
import Loading from '../Loading';
import { ButtonStyled, ButtonWrapper } from './Button.style';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: ReactNode;
  buttonType?: string;
  fullwidth?: boolean;
  loading?: boolean;
  icon?: ReactNode;
}

const Button: FC<ButtonProps> = ({
  label,
  buttonType,
  type = 'button',
  fullwidth = false,
  loading = false,
  icon,
  ...rest // ✅ this is where extra props like onClick, aria-*, etc. go
}) => {
  return (
    <ButtonWrapper className={buttonType} fullwidth={fullwidth} loading={loading}>
      <ButtonStyled type={type} fullwidth={fullwidth} {...rest}>
        {icon}
        {loading ? <Loading /> : label}
      </ButtonStyled>
    </ButtonWrapper>
  );
};

export default Button;
